var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"min-vh-100"},[_c('b-row',{staticClass:"w-100 no-gutters"},[_c('b-col',{staticClass:"text-lg-left"},[_c('h1',{staticClass:"mr-sm-4"},[_vm._v("DASHBOARD")])])],1),_c('div',{staticClass:"bg-white-border px-4 px-sm-5 py-4 mt-4"},[_c('Chart')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }